import { defineComponent, h, type Component, type PropType } from 'vue'

const CardBase = defineComponent({
  name: 'CardBase',
  setup:
    (_, { slots }) =>
    () =>
      h(
        'div',
        {
          class:
            'w-full bg-white rounded-[12px] border border-[#cccccc]/50 px-4 tablet-h:px-6',
        },
        slots.default?.()
      ),
})

const CardTitle = defineComponent({
  name: 'CardTitle',
  props: {
    icon: {
      type: Object as PropType<Component>,
      default: undefined,
    },
  },
  setup:
    (props, { slots }) =>
    () =>
      h(
        'div',
        { class: 'flex items-center pt-4 pb-4 border-b border-[#efefef]' },
        [
          props.icon &&
            h(props.icon, {
              class: 'size-[18px] mr-[9px] shrink-0 text-gray-800',
            }),
          h(
            'div',
            {
              class:
                'w-full text-[16px] leading-[22px] font-medium text-gray-800',
            },
            slots.default?.()
          ),
        ]
      ),
})

const CardContent = defineComponent({
  name: 'CardContent',
  setup:
    (_, { slots }) =>
    () =>
      h(
        'div',
        { class: 'pt-[22px] pb-6 text-[14px] leading-[18px] text-gray-800' },
        slots.default?.()
      ),
})

const CardSeparator = defineComponent({
  name: 'CardSeparator',
  setup: () => () => h('div', { class: 'my-[22px] w-full h-px bg-[#efefef]' }),
})

export const Card = {
  Base: CardBase,
  Title: CardTitle,
  Content: CardContent,
  Separator: CardSeparator,
}
